module.exports = __webpack_public_path__ + "static/img/34.7d8ff2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/word/34.png
// module id = 5RaX
// module chunks = 1